import React from "react";
import LandingPage from "./components/LandingPage";
import "./App.css";

function App() {
  return (
    <div className="full-width-app">
      <LandingPage />
    </div>
  );
}

export default App;